import { a as oe, C as re, D as se, M as le, R as ce, V as ie } from "./ModalWrapper-CCQXkR0_.mjs";
import { jsx as r, jsxs as b } from "react/jsx-runtime";
import _ from "clsx";
import { useRef as v, useImperativeHandle as w, useState as I, useEffect as T, createElement as k, useCallback as L } from "react";
import C from "animejs";
import B from "next/link";
import { useCurrentLocale as N } from "next-i18n-router/client";
import { i18nConfig as E } from "./lib.js";
import { C as R } from "./Content-NknxWl0R.mjs";
import { g as $ } from "./getUrlWithLocale-Sb9sJa1R.mjs";
import "date-fns";
import "date-fns/locale";
import "next/headers";
import "./_baseToString-CcsvGzgN.mjs";
import "react-use";
import "body-scroll-lock";
const O = ({ size: t = 200, color: n = "currentColor", className: o, ...s }) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: o,
    ...s,
    children: /* @__PURE__ */ r(
      "circle",
      {
        cx: "50",
        cy: "50",
        fill: "none",
        stroke: n,
        strokeWidth: "10",
        r: "35",
        strokeDasharray: "164.93361431346415 56.97787143782138",
        transform: "matrix(1, 0, 0, 1, 0, 0)",
        children: /* @__PURE__ */ r(
          "animateTransform",
          {
            attributeName: "transform",
            type: "rotate",
            repeatCount: "indefinite",
            dur: "1s",
            keyTimes: "0;1",
            values: "0 50 50;360 50 50"
          }
        )
      }
    )
  }
), H = "Loader-module_loader__Ukoov", W = {
  loader: H
};
function F({ className: t }) {
  return /* @__PURE__ */ r(O, { className: _(W.loader, t) });
}
const M = "Button-module_btn__daEdK", S = "Button-module_outline__TFr94", U = "Button-module_loading__QfItr", Y = "Button-module_spin__kQKH9", j = "Button-module_btnContent__ydXzc", J = "Button-module_content__PpYVU", K = "Button-module_loader__KKJJD", p = {
  btn: M,
  outline: S,
  loading: U,
  spin: Y,
  btnContent: j,
  content: J,
  loader: K,
  "btn-xs": "Button-module_btn-xs__R9haU",
  "btn-sm": "Button-module_btn-sm__KNlkv",
  "btn-md": "Button-module_btn-md__C8vqh",
  "btn-lg": "Button-module_btn-lg__zDd8X",
  "btn-primary": "Button-module_btn-primary__vwY5K",
  "btn-secondary": "Button-module_btn-secondary__w3xYM",
  "btn-success": "Button-module_btn-success__vIh-I",
  "btn-transparent": "Button-module_btn-transparent__nY-p4"
};
function D({
  size: t,
  color: n = "success",
  outline: o = !1,
  loading: s = !1,
  className: e,
  children: l,
  ...a
}) {
  const m = _(
    p.btn,
    p[`btn-${n}`],
    {
      [p[`btn-${t}`]]: t,
      [p.outline]: o,
      [p.loading]: s
    },
    e
  );
  return /* @__PURE__ */ b("button", { className: m, ...a, children: [
    /* @__PURE__ */ r("span", { className: p.content, children: l }),
    s && /* @__PURE__ */ r(F, { className: p.loader })
  ] });
}
const q = "Input-module_inputWrapper__TYJbS", A = "Input-module_withIcon__ToU6Q", P = "Input-module_input__505b7", V = "Input-module_icon__qkecR", g = {
  inputWrapper: q,
  withIcon: A,
  input: P,
  icon: V
};
function X(t) {
  return /* @__PURE__ */ b("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    /* @__PURE__ */ r(
      "path",
      {
        d: "M11.059 18.118C14.9576 18.118 18.118 14.9576 18.118 11.059C18.118 7.16042 14.9576 4 11.059 4C7.16042 4 4 7.16042 4 11.059C4 14.9576 7.16042 18.118 11.059 18.118Z",
        stroke: "#1E1F1E",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ r("path", { d: "M20.0721 20.0718L16.1221 16.1218", stroke: "#1E1F1E", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function Xt({ hasIcon: t = !1, className: n, placeholder: o, ...s }, e) {
  const l = v(null);
  return w(e, () => l.current), /* @__PURE__ */ b("div", { className: _(g.inputWrapper, t && g.withIcon), children: [
    /* @__PURE__ */ r("input", { ref: l, className: _(g.input, n), placeholder: o, ...s }),
    t && /* @__PURE__ */ r("span", { className: g.icon, children: /* @__PURE__ */ r(X, {}) })
  ] });
}
const G = "FormControl-module_wrapper__YTIL9", Q = "FormControl-module_hasError__Esjds", Z = "FormControl-module_error__fuU0f", z = "FormControl-module_hint__OYj42", tt = "FormControl-module_activeHint__wcVJK", et = "FormControl-module_title__TRovM", f = {
  wrapper: G,
  hasError: Q,
  error: Z,
  hint: z,
  activeHint: tt,
  title: et
};
function Gt({ title: t, children: n, error: o, hint: s, htmlFor: e, activeHint: l, className: a }) {
  return /* @__PURE__ */ b("div", { className: _(f.wrapper, "text", !!o && f.hasError, a), children: [
    !!t && /* @__PURE__ */ r("label", { htmlFor: e, className: _(f.title, "h3"), children: t }),
    n,
    !!s && /* @__PURE__ */ r("div", { className: _(f.hint, l && f.activeHint, "text-sm"), children: s }),
    !!o && /* @__PURE__ */ r("div", { className: _(f.error, "text-sm"), children: o })
  ] });
}
function Qt({
  className: t,
  enabled: n = !0,
  delay: o = 500,
  rotate: s = 0,
  text: e,
  white: l,
  purple: a,
  children: m
}) {
  const [u, d] = I(n), i = v(null);
  return T(() => {
    const c = setTimeout(() => {
      d((y) => y || n);
    }, o);
    return () => clearTimeout(c);
  }, [n, o]), T(() => {
    const c = i.current;
    if (c && u)
      return c.style.opacity = "0", C({
        targets: c,
        easing: "spring(1, 100, 10, 0)",
        scale: 1,
        opacity: 1,
        delay: o
      }), () => {
        C.remove(c);
      };
  }, [u, i, o, s]), /* @__PURE__ */ r(
    "span",
    {
      ref: i,
      style: {
        display: "inline-flex",
        opacity: 0,
        transformOrigin: "left",
        willChange: "opacity",
        transform: `rotate(${s}deg) scale(1.5)`
      },
      className: _(t, "stuffing", {
        "stuffing-white": l,
        "stuffing-purple": a,
        "stuffing-orange": !l && !a
      }),
      children: m || e
    }
  );
}
function Zt({ href: t, locale: n, children: o, ...s }, e) {
  const l = v(null), a = N(E), m = n || a, u = typeof t == "string" ? t : t ? `${t.pathname || ""}${t.query ? `?${new URLSearchParams(t.query).toString()}` : ""}` : "", d = u ? $(u, m) : "";
  return w(e, () => l.current), /* @__PURE__ */ r(B, { href: d, locale: m, prefetch: !1, ...s, ref: l, children: o });
}
const nt = "Text-module_text__XXjeA", ot = "Text-module_xs__cPxPp", rt = "Text-module_sm__fl9vD", st = "Text-module_md__kiT9j", lt = "Text-module_lg__nPLfy", ct = "Text-module_left__mLCig", it = "Text-module_center__tNTJk", at = "Text-module_right__WlaBU", ut = "Text-module_overflow__mfOvl", mt = "Text-module_lighter__Ac1E0", dt = "Text-module_normal__8e8-I", _t = "Text-module_bold__ZRBJh", pt = "Text-module_bolder__TDnBT", ft = "Text-module_inherit__3m48G", ht = "Text-module_white__CcYJW", xt = "Text-module_info__ABlmk", bt = "Text-module_dark__apstj", gt = "Text-module_darkLight__zci2U", vt = "Text-module_secondary__21S6G", Tt = "Text-module_secondaryLight__ZtnRi", wt = "Text-module_warning__uRHSW", yt = "Text-module_error__efqQU", Ct = "Text-module_primary__nfG7f", It = "Text-module_success__qYdpb", h = {
  text: nt,
  xs: ot,
  sm: rt,
  md: st,
  lg: lt,
  left: ct,
  center: it,
  right: at,
  overflow: ut,
  lighter: mt,
  normal: dt,
  bold: _t,
  bolder: pt,
  inherit: ft,
  white: ht,
  info: xt,
  dark: bt,
  darkLight: gt,
  secondary: vt,
  secondaryLight: Tt,
  warning: wt,
  error: yt,
  primary: Ct,
  success: It
};
function zt({ as: t = "p", children: n, overflow: o, className: s, weight: e = "normal", color: l, size: a = "md", textAlign: m, ...u }, d) {
  const i = v(null);
  w(d, () => i.current);
  const c = _(
    h.text,
    h[a],
    h[e],
    o && h.overflow,
    m && h[m],
    l && h[l],
    s
  );
  return k(t, { className: c, ref: i, ...u }, n);
}
function Lt() {
  return L((t) => {
    const n = document.getElementById(t);
    n && n.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);
}
function kt(t, n = 145, o = 40) {
  const [s, e] = I(null), l = L((a) => {
    var d;
    const u = (d = a.filter((i) => i.isIntersecting).sort((i, c) => i.boundingClientRect.top - c.boundingClientRect.top)[0]) == null ? void 0 : d.target.id;
    u && e((i) => i !== u ? u : i);
  }, []);
  return T(() => {
    const m = -(window.innerHeight - (n + o)), u = `-${n}px 0px ${m}px 0px`, d = new IntersectionObserver(l, {
      rootMargin: u
    }), i = t.map(({ elementId: c }) => document.getElementById(c)).filter((c) => c !== null);
    return i.forEach((c) => d.observe(c)), () => {
      i.forEach((c) => d.unobserve(c)), d.disconnect();
    };
  }, [t, l, n, o]), s;
}
const Bt = "TableOfContents-module_toc__KGeT0", Nt = "TableOfContents-module_item__flyny", Et = "TableOfContents-module_dot__NxmbJ", Rt = "TableOfContents-module_active__XFC-u", $t = "TableOfContents-module_text__tAmle", x = {
  toc: Bt,
  item: Nt,
  dot: Et,
  active: Rt,
  text: $t
};
function Ot({ title: t, headings: n }) {
  const o = kt(n), s = Lt();
  return /* @__PURE__ */ b("div", { children: [
    /* @__PURE__ */ r("span", { className: "h4", children: t }),
    /* @__PURE__ */ r("nav", { className: x.toc, children: /* @__PURE__ */ r("ul", { children: n.map((e) => /* @__PURE__ */ r(
      "li",
      {
        className: _(x.item, "text", {
          [x.active]: o === e.elementId,
          [x.dot]: e.level === 2
        }),
        style: { marginLeft: `${(e.level - 2) * 20}px` },
        children: /* @__PURE__ */ r(D, { color: "transparent", onClick: () => s(e.elementId), children: /* @__PURE__ */ r(
          "span",
          {
            className: _(x.text, { [x.active]: o === e.elementId }, "text text-sm"),
            "data-text": e.text,
            children: /* @__PURE__ */ r("span", { children: e.text })
          }
        ) })
      },
      e.elementId
    )) }) })
  ] });
}
function te({ blocks: t, ...n }) {
  const o = t.reduce((s, e) => {
    var l;
    return e.type === R.Type.header && ((l = e.data) != null && l.text) && s.push({
      elementId: e.data.elementId,
      text: e.data.text,
      level: e.data.level || 2
    }), s;
  }, []);
  return o.length ? /* @__PURE__ */ r(Ot, { headings: o, ...n }) : null;
}
export {
  D as Button,
  oe as CloseBtn,
  re as CopyLink,
  se as DataLayer,
  Gt as FormControl,
  Zt as I18nLink,
  Xt as Input,
  F as Loader,
  le as ModalWrapper,
  ce as Row,
  Qt as Stamp,
  te as TableOfContents,
  zt as Text,
  ie as VideoEmbed
};
//# sourceMappingURL=components.js.map
